import StudentOvertakeClassCoordinator from "../views/schooladmin/StudentOvertakeClassCoordinator";
import StudentOvertakeClassCoordinatorAddEdit from "../views/schooladmin/StudentOvertakeClassCoordinatorAddEdit";

export default [
  {
    path: "/schooladmin/student_overtake_class_coordinator",
    components: {
      content: StudentOvertakeClassCoordinator
    }
  },
  {
    path: "/schooladmin/student_overtake_class_coordinator/new",
    components: {
      content: StudentOvertakeClassCoordinatorAddEdit
    }
  },
  {
    path: "/schooladmin/student_overtake_class_coordinator/update/:id",
    components: {
      content: StudentOvertakeClassCoordinatorAddEdit
    },
    props: {
      content: true
    }
  }
];
